export default function AboutSection() {
  return (
    <section id="sobre-mi" className="py-16 md:py-24 bg-[#111e30]">
      <div className="max-w-7xl mx-auto px-5 md:px-6 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10 items-center">
          {/* Left Column - Image */}
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="relative rounded-[30px] md:rounded-[40px] overflow-hidden shadow-2xl">
                <img
                  src="https://static.readdy.ai/image/f9226af7b0c833b6273ae5c168cd92f2/4462287101cc7b9b236fdb58cb1e70f0.jpeg"
                  alt="Valentina Amigo - Abogada profesional en Córdoba"
                  className="w-full h-[380px] md:h-[520px] object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#14253D]/60 to-transparent"></div>
              </div>
              {/* Decorative circle */}
              <div className="absolute -bottom-4 -right-4 w-20 h-20 md:w-24 md:h-24 border-2 border-[#B89A5A]/30 rounded-full hidden md:block"></div>
              <div className="absolute -top-4 -left-4 w-12 h-12 md:w-16 md:h-16 bg-[#B89A5A]/10 rounded-full hidden md:block"></div>
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="lg:col-span-7">
            <div className="bg-[#14253D]/50 border border-white/8 rounded-[30px] md:rounded-[40px] p-7 md:p-10 lg:p-14 relative overflow-hidden">
              {/* Decorative Quotes */}
              <div className="absolute top-4 left-6 md:top-6 md:left-8 text-[#B89A5A] opacity-20 text-6xl md:text-8xl font-serif leading-none">
                &ldquo;
              </div>

              <div className="relative z-10 space-y-5 md:space-y-6">
                <div className="inline-flex items-center gap-2 border border-[#B89A5A]/30 rounded-full px-4 md:px-5 py-2 mb-1 md:mb-2">
                  <span className="text-[#B89A5A] text-xs md:text-sm font-medium tracking-wider">
                    CÓMO TRABAJAMOS
                  </span>
                </div>

                <p className="text-white/85 text-base md:text-lg lg:text-xl leading-relaxed">
                  Cada consulta es abordada de manera individual, entendiendo que detrás de cada caso hay una situación personal que requiere atención y compromiso.
                </p>
                <p className="text-white/85 text-base md:text-lg lg:text-xl leading-relaxed">
                  El trabajo se basa en un trato cercano, un análisis responsable de cada situación y un acompañamiento claro durante todo el proceso legal, con seriedad, compromiso y profesionalismo.
                </p>

                <div className="pt-5 md:pt-6 border-t border-white/10">
                  <h3 className="text-white text-xl md:text-2xl lg:text-3xl font-serif font-bold mb-1">
                    Valentina Amigo
                  </h3>
                  <p className="text-[#B89A5A] text-sm md:text-base">
                    Abogada - M.P. 1-43598
                  </p>
                </div>

                <a
                  href="#contacto"
                  className="inline-block bg-[#B89A5A] text-[#14253D] px-6 md:px-8 py-3.5 md:py-4 rounded-full text-sm md:text-base font-semibold hover:bg-[#A68A4A] transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Contactar
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}